// base exports from dayjs
import dayjs from 'dayjs';
// plugins
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import relativeTime from 'dayjs/plugin/relativeTime';

// custom utils
import { formatDate, formatDateTime } from './formatDate';
import { formatDateRange } from './formatDateRange/formatDateRange';
import { formatDateToDateTimeIsoString } from './formatDateToDateTimeIsoString/formatDateToDateTimeIsoString';
import { formatDateToIsoString } from './formatDateToIsoString';
import { getMinutesAsMilliseconds } from './getMinutesAsMilliseconds';
import { isWeekend } from './isWeekend/isWeekend';

export type { Dayjs } from 'dayjs';
export { isDayjs } from 'dayjs';

export {
  dayjs,
  formatDate,
  formatDateRange,
  formatDateTime,
  formatDateToDateTimeIsoString,
  formatDateToIsoString,
  getMinutesAsMilliseconds,
  isWeekend,
};

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);

export { duration, isSameOrAfter, relativeTime };
